import { useEffect } from "react";

export function useStarfieldScrollPause(scrollRef) {
  useEffect(() => {
    const el = scrollRef?.current;
    const starfield = document.getElementById("starfield");
    if (!el || !starfield) return undefined;

    let resumeTimer = null;
    const onScroll = () => {
      starfield.classList.add("starfield--paused");
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        starfield.classList.remove("starfield--paused");
      }, 180);
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      el.removeEventListener("scroll", onScroll);
      if (resumeTimer) clearTimeout(resumeTimer);
      starfield.classList.remove("starfield--paused");
    };
  }, [scrollRef]);
}
